import { Tag } from 'components/Toolkit/Tags/Tag';
import { WarrantyTagProps } from 'components/Toolkit/Tags/PreBuilt/WarrantyTag.typed';

function WarrantyTag(props: WarrantyTagProps) {
  const { text = 'Warranty' } = props;
  return <Tag text={text} textColor="GREY_DARK" bgColor="GREY_LIGHTER" />;
}

export { WarrantyTag };
